// Brand fonts loaded at app start (see _layout.tsx → useFonts). The keys here
// become the fontFamily names referenced via `fonts` in theme.ts. On web,
// expo-font injects the matching @font-face; on native they load from the
// bundled .ttf. Only the weights the UI actually uses are loaded.
import {
  BricolageGrotesque_700Bold,
  BricolageGrotesque_800ExtraBold,
} from "@expo-google-fonts/bricolage-grotesque";
import {
  HankenGrotesk_400Regular,
  HankenGrotesk_500Medium,
  HankenGrotesk_600SemiBold,
  HankenGrotesk_700Bold,
} from "@expo-google-fonts/hanken-grotesk";
import {
  SpaceMono_400Regular,
  SpaceMono_700Bold,
} from "@expo-google-fonts/space-mono";

export const brandFontMap = {
  BricolageGrotesque_700Bold,
  BricolageGrotesque_800ExtraBold,
  HankenGrotesk_400Regular,
  HankenGrotesk_500Medium,
  HankenGrotesk_600SemiBold,
  HankenGrotesk_700Bold,
  SpaceMono_400Regular,
  SpaceMono_700Bold,
};
